<template>
  <div id="app">
    <!-- <van-tabbar
      v-model="active"
      active-color="#07c160"
      inactive-color="#000"
      safe-area-inset-bottom
    >
      <van-tabbar-item name="otherRepay" to="/other-repay" icon="refund-o">
        代缴还款
      </van-tabbar-item>
      <van-tabbar-item name="selfRepay" to="/self-repay" icon="balance-o">
        本人还款
      </van-tabbar-item>
      <van-tabbar-item name="leaseInfo" to="/lease-info" icon="orders-o">
        租赁信息
      </van-tabbar-item>
      <van-tabbar-item name="register" to="/register" icon="manager-o">
        用户注册
      </van-tabbar-item>
    </van-tabbar> -->
    <router-view />
    <!-- <div class="blank"></div> -->
  </div>
</template>
<script>
import { Tabbar, TabbarItem } from "vant";
import { setToken } from "@/utils/auth.js";
import { getUrlParam } from "@/utils/url.js";
import { login, getOpenIdByCode } from "@/api/login.js";
export default {
  name: "App",
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data: function() {
    return {
      active: "home",
      weixinCode: "",
      state: "",
      openId: ""
    };
  },
  created() {
    console.log("App.vue created");
    // 调用微信及后台接口获取openID
    this.getWXCodeToTarget();
  },
  methods: {
    getWXCodeToTarget() {
      console.log("APP_getWXCodeToTarget");
      const code = getUrlParam("code"); // 获取当前页面地址中的code参数的值
      console.log("code", code);
      if (code === "" || code == null) {
        // URL不带code
      } else {
        // 能拿到code，说明用户已同意授权
        const state = getUrlParam("state");
        const data = {
          code: code,
          state: state + "wxstatenbcb"
        };
        console.log("获取微信code：", data, state);
        this.getOpenIdByCode(data, state);
      }
    },
    getOpenIdByCode(data, state) {
      getOpenIdByCode(this.$qs.stringify(data))
        .then(res => {
          console.info("res");
          console.info(res);
          if (res.data.code === 200) {
            // 已注册
            const openId = res.data.results;
            setToken(openId);
            this.loginById(openId, state);
            //跳转
            window.location.href = "/#" + state;
          } else if (res.data.code === 100) {
            // 未注册
            const openId = res.data.results;
            setToken(openId);
            this.loginById(openId, state);
          } else {
            this.$toast.fail(res.data.message);
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    loginById(openId, state) {
      console.log("loginById");
      const data = {
        wxId: openId
      };
      login(this.$qs.stringify(data))
        .then(res => {
          console.info(res);
          if (res.data.code === 200) {
            //跳转
            window.location.href = "/#" + state;
          } else {
            //去注册
            this.$dialog
              .confirm({
                title: "注册",
                message: "未查到您的用户信息，请先注册"
              })
              .then(() => {
                const path = state == '/yghdb/register' ? '/#/yghdb/register' : "/#/register";
                window.location.href = path;
              });
          }
        })
        .catch(error => {
          console.error(error);
          this.$toast.fail("请求失败！");
        });
    }
  }
};
</script>
<style lang="scss">
@import "src/styles/box-with-con.scss";
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  min-height: 100%;
  background-color: #eeeeee;
}
.blank {
  width: 100%;
  height: 50px;
}

* {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
input {
  -webkit-user-select: auto;
}
</style>
